import { Disciplines } from '../../domain';
import ResultsSJItem from './components/ResultsSJItem/ResultsSJItem.component';
import ResultsDRItem from './components/ResultsDRItem/ResultsDRItem.component';
import ResultsETItem from './components/ResultsETItem/ResultsETItem.component';
import ResultsCBItem from './components/ResultsCBItem/ResultsCBItem.component';
import ResultsHTItem from './components/ResultsHTItem/ResultsHTItem.component';
import ResultsSEItem from './components/ResultsSEItem/ResultsSEItem.component';

export default function getResultsTable(discipline?: Disciplines) {
  switch (discipline) {
    case Disciplines.Showjumping:
      return ResultsSJItem;
    case Disciplines.Dressage:
      return ResultsDRItem;
    case Disciplines.EventerTrial:
      return ResultsETItem;
    case Disciplines.CombinedTraining:
      return ResultsCBItem;
    case Disciplines.HunterTrials:
      return ResultsHTItem;
    case Disciplines.Shows:
    case Disciplines.MixedEvents:
      return ResultsSEItem;
    default:
      return ResultsDRItem;
  }
}
